import { RestClient } from "./restClient";

export interface GranolaActionItem {
  text: string;
  owner?: string;
  due?: string;
}

/** Mirrors granola_pending_meetings / _pending_row_to_dict on the backend. */
export interface GranolaPendingMeeting {
  id: string;
  note_id: string;
  title: string;
  transcript: string | null;
  summary: string | null;
  participants: string[] | null;
  action_items: GranolaActionItem[] | null;
  /** ISO 8601 timestamp, or null. */
  meeting_date: string | null;
  status: "pending" | "accepted" | "dismissed";
  created_at: string | null;
}

export interface GranolaPendingActionResult {
  ok: boolean;
  id: string;
  status: string;
  meeting_id?: string;
}

/**
 * Wraps the /v1/granola/pending review surface — meetings staged from a
 * Granola `note.generated` webhook (see
 * unified_agent/routes/granola_webhook_routes.py) awaiting an explicit
 * accept/dismiss from the MeetingKbBanner. Accept ingests the staged row
 * into the real knowledge base server-side; dismiss just marks it resolved.
 */
export class GranolaApi {
  constructor(private client: RestClient) {}

  listPending(): Promise<GranolaPendingMeeting[]> {
    return this.client
      .get<{ pending: GranolaPendingMeeting[] }>("/v1/granola/pending")
      .then((r) => r.pending);
  }

  accept(id: string): Promise<GranolaPendingActionResult> {
    return this.client.post<GranolaPendingActionResult>(
      `/v1/granola/pending/${encodeURIComponent(id)}/accept`,
    );
  }

  dismiss(id: string): Promise<GranolaPendingActionResult> {
    return this.client.post<GranolaPendingActionResult>(
      `/v1/granola/pending/${encodeURIComponent(id)}/dismiss`,
    );
  }
}
